class ModelsRegExp {

    public elementUnknown = /^[a-zA-Z0-9:]{8,40}$/;

    public elementSerialNumberMast = /^([A-Z]|\d){3}([A-Z]|\d){7}\d{5}$/;
    public elementSerialNumberSolarPanel = /^\d{6}([A-Z]|\d){3}([A-Z]|\d){20,31}$/;
    public elementSerialNumberEnergyBox = /^([A-Z]*)(\d){11}$/;
    public elementSerialNumberGateway = /^(([A-Z]*)(\d){10})|(\d{8})$/;

    public elementLoraIdEnergyBoxWithSeparator = /^(([0-9A-F]){2}[:]){7}([0-9A-F]){2}$/;
    public elementLoraIdEnergyBoxWithoutSeparator = /^([0-9A-F]){16}$/;

}

export default new ModelsRegExp();
